<template>
<section>
    <div class="services pt-0 pt-md-5">
        <div class="back-right d-none d-md-block"></div>

        <div class="container">
            <div class="pt-0 pt-md-5">
                <div class="title pt-2">
                     <label>{{$res('site.services.label')}}</label>
                    <span>{{$res('site.services.label')}}</span>
                </div>
                <div class="row">
                    <div class="col-sm-6 col-md-4" v-for="(item, index) in data" :key="index"
                    >
                        <div class="services-items" data-aos="fade-right">
                            <img :src="`${ rootImagePath +  item.imagePath }`" />
                            <h5>{{ item.name }}</h5>
                            <div>
                                <span>{{ item.caption }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </section>
</template>
<script>

    export default {
     props:{
         data:{
             type:Object
         },
             rootImagePath: {
                 type: String,
    },
     }

    };
</script>
<style scoped>

    .services {
        width: 100%;
        min-height: 500px;
        position: relative;
    }
/*
        .services .back-right {
            width: 500px;
            height: 700px;
            opacity: 0.8;
            background-repeat: no-repeat;
            background-size: cover;
            position: absolute;
            top: 100px;
            z-index: 0;
            right: -200px;
            background-image: url("../../assets/images/pic-right.svg");
        }
*/
        .services .title {
            float: left;
            width: 100%;
            position: relative;
        }

            .services .title,
            .services .title label,
            .services .title span {
                text-align: center;
                width: 100%;
                height: 70px;
            }

                .services .title label {
                    font-size: 30px;
                    margin: 0;
                    color: #ebc75d;
                    z-index: 1;
                    position: relative;
                }

                .services .title span {
                    font-size: 50px;
                    opacity: 0.5;
                    color: #f1f1f1;
                    margin-top: -80px;
                    z-index: 0;
                    display: block;
                }

        .services img {
            width: 80px;
        }

    .services-items {
        width: 100%;
        min-height: 350px;
        margin-bottom: 20px;
        background:#fff;
        padding: 30px;
        z-index: 1;
        float: left;
        text-align: center;
        transition: all 2s;
        cursor: pointer;
        position: relative;
        border-radius: 100%;
        box-shadow: 10px 5px 5px rgb(216, 213, 213);
        transition: 1s all;
    }

        .services-items:hover {
            box-shadow: unset;
        }

        .services-items h5 {
            text-align: center;
            padding-top: 20px;
        }

        .services-items img {
            float: top;
        }

    @media screen and (max-width: 576px) {
        .services {
            padding-top: 0;
        }
    }
</style>